import { render, staticRenderFns } from "./CompanyShifts.vue?vue&type=template&id=5979bc30"
import script from "./CompanyShifts.vue?vue&type=script&lang=js"
export * from "./CompanyShifts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports